/* tslint:disable */
import { CalculationParameter } from './calculation-parameter';

/**
 */
export class OperatingSettingParam {
    eid?: number;
    doTr?: boolean;
    tr?: number[];
    ts?: number[];
    vc?: number[];
    TExt?: number;
    calculation_parameter?: CalculationParameter;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/operating-setting-param.ts